import { render, staticRenderFns } from "./PsiCompare.vue?vue&type=template&id=0aecb14d"
import script from "./PsiCompare.vue?vue&type=script&lang=js"
export * from "./PsiCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports